import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
import { instrumentMethod } from '../tools/instrumentMethod';
import { monitorError } from '../tools/monitor';
import { Observable } from '../tools/observable';
import { clocksNow } from '../tools/utils/timeUtils';
import { normalizeUrl } from '../tools/utils/urlPolyfill';
import { globalObject } from '../tools/globalObject';
import { readBytesFromStream } from '../tools/readBytesFromStream';
import { tryToClone } from '../tools/utils/responseUtils';
var fetchObservable;
var responseBodyActionGetters = [];
export function initFetchObservable() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    responseBodyAction = _ref.responseBodyAction;
  if (responseBodyAction) {
    responseBodyActionGetters.push(responseBodyAction);
  }
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }
  return fetchObservable;
}
export function resetFetchObservable() {
  fetchObservable = undefined;
  responseBodyActionGetters.length = 0;
}
function createFetchObservable() {
  return new Observable(function (observable) {
    // eslint-disable-next-line local-rules/disallow-zone-js-patched-values
    if (!globalObject.fetch) {
      return;
    }
    var _instrumentMethod = instrumentMethod(globalObject, 'fetch', function (call) {
        return beforeSend(call, observable);
      }, {
        computeHandlingStack: true
      }),
      stop = _instrumentMethod.stop;
    return stop;
  });
}
function beforeSend(_ref2, observable) {
  var parameters = _ref2.parameters,
    onPostCall = _ref2.onPostCall,
    handlingStack = _ref2.handlingStack;
  var _a, _b;
  var _parameters = _slicedToArray(parameters, 2),
    input = _parameters[0],
    init = _parameters[1];
  var methodFromParams = init && init.method;
  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }
  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack,
    isAbortedOnStart: input instanceof Request && ((_a = input.signal) === null || _a === void 0 ? void 0 : _a.aborted) || ((_b = init === null || init === void 0 ? void 0 : init.signal) === null || _b === void 0 ? void 0 : _b.aborted) || false
  };
  observable.notify(context);
  // Those properties can be changed by observable subscribers
  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    afterSend(observable, responsePromise, context)["catch"](monitorError);
  });
}
function afterSend(_x, _x2, _x3) {
  return _afterSend.apply(this, arguments);
}
function _afterSend() {
  _afterSend = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(observable, responsePromise, startContext) {
    var _a, _b, context, response, responseBodyCondition, clonedResponse, bytes, _t, _t2;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          context = startContext;
          context.state = 'resolve';
          _context.prev = 1;
          _context.next = 2;
          return responsePromise;
        case 2:
          response = _context.sent;
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          context.status = 0;
          context.isAborted = ((_b = (_a = context.init) === null || _a === void 0 ? void 0 : _a.signal) === null || _b === void 0 ? void 0 : _b.aborted) || _t instanceof DOMException && _t.code === DOMException.ABORT_ERR;
          context.error = _t;
          observable.notify(context);
          return _context.abrupt("return");
        case 4:
          context.response = response;
          context.status = response.status;
          context.responseType = response.type;
          context.isAborted = false;
          responseBodyCondition = responseBodyActionGetters.reduce(function (action, getter) {
            return Math.max(action, getter(context));
          }, 0 /* ResponseBodyAction.IGNORE */);
          if (!(responseBodyCondition !== 0 /* ResponseBodyAction.IGNORE */)) {
            _context.next = 8;
            break;
          }
          clonedResponse = tryToClone(response);
          if (!(clonedResponse && clonedResponse.body)) {
            _context.next = 8;
            break;
          }
          _context.prev = 5;
          _context.next = 6;
          return readBytesFromStream(clonedResponse.body, {
            collectStreamBody: responseBodyCondition === 2 /* ResponseBodyAction.COLLECT */
          });
        case 6:
          bytes = _context.sent;
          context.responseBody = bytes && new TextDecoder().decode(bytes);
          _context.next = 8;
          break;
        case 7:
          _context.prev = 7;
          _t2 = _context["catch"](5);
        case 8:
          observable.notify(context);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3], [5, 7]]);
  }));
  return _afterSend.apply(this, arguments);
}